import useAccessControl from '../../legacy/components/AccessControl/useAccessControl'
import { FeatureToggle } from '../../legacy/contexts/featureToggles/FeatureToggleContext'
import { ICPlatformVersion } from '../../utils/ic-platform/versioning'

/**
 * Hook to check if the role groups feature is enabled.
 *
 * This checks both the feature toggle (rt_role_groups_enabled) and
 * the minimum IC Platform version (r2026_01_0).
 *
 * @returns {boolean} Whether role groups feature is enabled
 */
export const useUserGroupsEnabled = (): boolean => {
  const hasAccess = useAccessControl()

  return hasAccess({
    featureToggles: [FeatureToggle.userGroupsEnabled],
    minICPlatformVersion: ICPlatformVersion.r2026_01_0,
  })
}
